import TaxAddress from 'components/RichProfile/MyAccount/TaxClaim/TaxAddress/TaxAddress';
import { withTaxAddressProps } from 'viewModel/richProfile/myAccount/taxClaim/withTaxAddressProps';

export default withTaxAddressProps(TaxAddress);
